import { applyActiveEffect } from './combatTimeline';

export const SLOW_DEFINITION_ID = 'weapon-mastery:slow';
export const SLOW_SPEED_MODIFIER = -10;

const masteryKey = (attack) => String(
  attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || ''
).trim().toLowerCase();

export const isSlowMasteryAttack = (attack) => Boolean(
  attack?.kind === 'weapon' && attack?.hasWeaponMastery && masteryKey(attack) === 'slow'
);

export const qualifiesForSlow = ({ attack, outcome, damageApplied, attackerId, targetId, combatState }) =>
  isSlowMasteryAttack(attack) && ['hit', 'critical-hit'].includes(outcome) && Number(damageApplied) > 0 &&
  Boolean(attackerId && targetId && Number.isInteger(combatState?.turnSequence) && combatState?.activeTurn != null);

export const createSlowDecision = (resolutionId) => ({
  id: `${resolutionId}:${SLOW_DEFINITION_ID}`,
  featureId: SLOW_DEFINITION_ID,
  resolutionId,
  title: 'Weapon Mastery: Slow',
  label: 'Weapon Mastery: Slow',
  prompt: "Reduce this creature's Speed by 10 feet?",
  choices: [{ id: 'apply', label: 'Apply Slow' }, { id: 'skip', label: 'Skip' }],
});

export const createSlowEffect = ({ attackerId, targetId, resolutionId, sourceWeaponInstanceId }) => ({
  id: `slow:${resolutionId}`,
  definitionId: SLOW_DEFINITION_ID,
  name: 'Slow · -10 ft Speed',
  icon: '🐌',
  userVisible: true,
  sourceCombatantId: attackerId,
  targetCombatantId: targetId,
  sourceResolutionId: resolutionId,
  ...(sourceWeaponInstanceId ? { sourceWeaponInstanceId } : {}),
  modifiers: [{ type: 'speed', operation: 'add', value: SLOW_SPEED_MODIFIER, stackingGroup: SLOW_DEFINITION_ID }],
  expiration: { type: 'sourceTurn', combatantId: attackerId, boundary: 'start', remainingOccurrences: 1 },
  // Each source owns its duration. The derived speed pipeline caps the shared
  // mastery reduction, so concurrent attackers remain independently expirable.
  stackKey: `${SLOW_DEFINITION_ID}:${attackerId}:${targetId}`,
  stackPolicy: 'refresh',
  description: 'Speed reduced by 10 feet.',
});

export const applySlowEffect = (combatState, input) => applyActiveEffect(combatState, createSlowEffect(input));
